import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { useComponentSize, useFlag } from '@carnica/utils/hooks';
import { useListener, useOnlineStatus } from "../../../../../lib";
import { FSMStages, useFSM } from "../../../FSM";
import { LoadingStatus } from "../../../../redux";
export var useScroll = function useScroll(params) {
  var loadingStatus = params.loadingStatus,
    isHistoryEmpty = params.isHistoryEmpty,
    zoneType = params.zoneType;
  var containerRef = useRef(null);
  var scrollRef = useRef(null);
  var _useComponentSize = useComponentSize(containerRef),
    containerHeight = _useComponentSize.height;
  var _useComponentSize2 = useComponentSize(scrollRef),
    scrollHeight = _useComponentSize2.height;
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var isOnline = useOnlineStatus();
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isListenerActive = _useFlag2[0],
    setIsListenerActive = _useFlag2[1];
  var _useFlag3 = useFlag(),
    _useFlag4 = _slicedToArray(_useFlag3, 2),
    isScrollButtonVisible = _useFlag4[0],
    setIsScrollButtonVisible = _useFlag4[1];
  var isTrackerActive = useRef(false);
  var scrollToBottom = function scrollToBottom(timeout) {
    var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'smooth';
    var scroll = function scroll() {
      var _scrollRef$current, _scrollRef$current2;
      return (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollTo({
        top: ((_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.scrollHeight) || 0,
        behavior: behavior
      });
    };
    if (typeof timeout === 'number') {
      setTimeout(scroll, timeout);
    } else {
      scroll();
    }
  };
  var handleScroll = useCallback(function (e) {
    if (isTrackerActive.current) {
      var _ref = e,
        currentTarget = _ref.currentTarget;
      // Необходимо для того чтоб не отображалась кнопка в момент автоскрола
      setTimeout(function () {
        var scrollTop = currentTarget.scrollTop,
          scrollSize = currentTarget.scrollHeight,
          offsetHeight = currentTarget.offsetHeight;
        if (scrollTop < scrollSize - offsetHeight * 1.5) {
          setIsScrollButtonVisible.on();
        } else {
          setIsScrollButtonVisible.off();
        }
      }, 500);
    }
  }, []);
  useListener('scroll', handleScroll, {
    target: scrollRef,
    active: isListenerActive
  });
  useLayoutEffect(function () {
    var loadFinished = loadingStatus === LoadingStatus.fulfilled || loadingStatus === LoadingStatus.failed;
    if (zoneType === 'authorized' && loadFinished || zoneType === 'unauthorized' && (stage !== FSMStages.ACTIVE || loadFinished) || !isOnline) {
      scrollToBottom(0, 'auto');
    }
  }, [loadingStatus, stage]);
  useEffect(function () {
    isTrackerActive.current = loadingStatus !== LoadingStatus.loading && !isHistoryEmpty;
  }, [loadingStatus, isHistoryEmpty]);
  useEffect(function () {
    if (isOnline) {
      setIsListenerActive.off();
    }
  }, []);
  return {
    isScrollButtonVisible: isScrollButtonVisible,
    scrollToBottom: scrollToBottom,
    onListMount: setIsListenerActive.on,
    containerRef: containerRef,
    scrollRef: scrollRef,
    scrollHeight: scrollHeight,
    containerHeight: containerHeight
  };
};